export default {
  uploadFile: "/third/api/tencentUpload/upload/file/local",
  examPhotoAdd: "/yangtse/admin/examPhoto/add",
};
